import React, { Component } from 'react'
import Helmet from 'react-helmet'
import PropTypes from 'prop-types'
import 'whatwg-fetch'

import Header from '../components/Header'
import Footer from '../components/Footer'

import favicon_image from '../images/favicon.ico'

import '../scss/main.scss'

function getCurrentJobs()
{
	return window.fetch('https://jsapi.recruiterbox.com/v1/openings?client_name=locuslabs', {
				method: 'GET',
				headers: {
						'Content-Type': 'application/json',
					},
				mode: 'cors',
				cache: 'default'
			}
		)
		.then(res => res.json())
		.then(jobs => {
				return jobs
		})
}

export default class TemplateWrapper extends Component {
    static propTypes = {
        children: PropTypes.func,
    }

    componentDidMount() {
        require('../executables/jquery.main')()
        if(window.location.hash.indexOf('contact') !== -1)
        {
            setTimeout(scrollToElement,100,'contact')

            function scrollToElement(elementId){
                let bodyRect = document.body.getBoundingClientRect(),
                    elemRect = document.getElementById(elementId).getBoundingClientRect(),
                    y_offset   = elemRect.top - bodyRect.top;

                window.scrollTo(0,y_offset)
            }
        }

        if (typeof window !== `undefined`) {
            $(function() {
                $.getJSON("https://api.ipify.org?format=jsonp&callback=?",
                    function(json) {
                        window.ip = json.ip
                    }
                );
            });

            getCurrentJobs()
                .then(jobs => { window.jobs = jobs })

        }
    }

    componentDidUpdate() {
        if (typeof window !== `undefined`) window.location.reload()
    }

    shouldComponentUpdate() {
        return true
    }

    render() {
        let darkTheme = false

        switch (this.props.location.pathname) {
            case '/':
                darkTheme = true
                break
            case '/about':
                darkTheme = true
                break
        }

        return (
            <div>
                <Helmet
                    meta={[
                        {name: 'description', content: 'Sample'},
                        {name: 'keywords', content: 'sample, something'},
                    ]}
                >
                    <link rel="icon" type="image/x-icon" href={favicon_image} />
                    <link rel="stylesheet" href="https://use.typekit.net/ayj6gmk.css"/>
                </Helmet>
                <Header darkTheme={darkTheme}/>
                {this.props.children()}
                <Footer/>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/layouts/index.js